import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheckCircle, FiStar, FiShield } = FiIcons;

const Hero = () => {
  return (
    <section className="relative pt-32 pb-20 md:pt-48 md:pb-32 px-6 lg:px-8 overflow-hidden min-h-[90vh] flex items-center">
      {/* Background with overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1524661135-423995f22d0b?q=80&w=2000&auto=format&fit=crop" 
          alt="Map dashboard" 
          className="w-full h-full object-cover opacity-20 mix-blend-luminosity"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/90 via-navy/95 to-navy"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal/10 border border-teal/20 text-teal font-semibold text-sm mb-8">
            <span className="w-2 h-2 rounded-full bg-teal animate-pulse"></span>
            Comprehensive Trust & Visibility Audit
          </div>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[1.1] tracking-tight mb-8">
            Recover Visibility, Trust, and Revenue in the <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-teal-400">AI Search Era</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-slate-300 mb-10 leading-relaxed max-w-3xl mx-auto">
            Most local businesses don't have a traffic problem. They have a trust problem. I'll show you exactly where your online trust is weak, what is costing you visibility, and what to fix first.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <a href="#book" className="w-full sm:w-auto bg-teal text-navy px-10 py-5 rounded-lg text-xl font-bold hover:bg-teal-400 transition-all shadow-[0_0_20px_rgba(0,212,200,0.3)] hover:shadow-[0_0_30px_rgba(0,212,200,0.5)] transform hover:-translate-y-1">
              Book Your Audit
            </a>
            <a href="#deliverables" className="w-full sm:w-auto bg-white/5 text-white backdrop-blur-md border border-white/10 px-10 py-5 rounded-lg text-xl font-bold hover:bg-white/10 transition-all">
              See What's Included
            </a>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm font-medium text-slate-400">
            <span className="flex items-center gap-2">
              <SafeIcon icon={FiShield} className="text-teal" />
              Trusted by 150+ local businesses
            </span>
            <span className="flex items-center gap-2">
              <div className="flex text-teal">
                {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiStar} className="fill-current w-4 h-4" />)}
              </div>
              4.9/5 average rating
            </span>
            <span className="flex items-center gap-2">
              <SafeIcon icon={FiCheckCircle} className="text-teal" />
              Clear, actionable roadmap
            </span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;